<template>
  <div style="background-color: yellow;">
    <el-image-viewer
    :url-list="urlList"
    :initial-index="initialIndex"
    :on-close="closeImageViewer"
     />
  </div>
</template>

<script>
export default {
  name: "ImagePreviewVue",
  props: {
    pictureList: {
      type: Array,
      default: []
    },
    initialIndex: {
      type: Number,
      default: 0,
    }
  },
  components: {
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')
  },
  data() {
    return {
      urlList: [],
    }
  },
  mounted() {

    this.initData();
  },
  methods: {
    initData() {
      console.log('---1');
      let pictureList = this.pictureList;
      if (pictureList == []) {
        return;
      }
      let tmpArray = [];
      for (let i = 0; i < pictureList.length; i++) {
        let item = pictureList[i];
        tmpArray.push(item.url);
      }
      this.urlList = tmpArray;
      this.showImgViewer();
    },
    showImgViewer() {
      const m = (e) => { e.preventDefault() };
      document.body.style.overflow = 'hidden';
      document.addEventListener('touchmove', m, false);
    },
    closeImageViewer() {
      const m = (e) => { e.preventDefault() };
      document.body.style.overflow = 'auto';
      document.removeEventListener('touchmove', m, true);
      this.$emit("close");
    },
  },

}
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/common/ImagePreview.vue